<template>
  <list-layout :tableTools="false">
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
        <el-form ref="ruleForm" :rules="rules" :model="form" class="flex-1">
          <el-form-item prop="receiver">
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template slot="table-core">
      <base-table-pagination v-if="!isLower1650 || isLower1024"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <base-table-pagination-mini v-else
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination-mini>
      <div class="flex flex-row space-x-2">
        <base-table-select-more-actions-form :name="$t('app.new')" size="xs" dir="down" custom-class="bg-secondary-800" :disabled="isGeneralLoading" @mainclick="goSociedadCreation">
          <template slot="more">
            <span>
              <base-button-item-list theme="dark" @click="goSociedadCreation"  :disabled="isGeneralLoading">
                <base-icon name="send" class="mr-2" />
                <div class="w-72 text-left">
                  {{ $t('agenda.sociedad') }}
                </div>
              </base-button-item-list>
            </span>
            <span>
              <base-button-item-list theme="dark" @click="toggleSedeDialog"  :disabled="isGeneralLoading">
                <base-icon name="send" class="mr-2" />
                <div class="w-72 text-left">
                  {{ $t('sedes.entity_name') }}
                </div>
              </base-button-item-list>
            </span>
            <span>
              <base-button-item-list theme="dark" @click="toggleAdminCenterDialog"  :disabled="isGeneralLoading">
                <base-icon name="send" class="mr-2" />
                <div class="w-72 text-left">
                  {{ $t('administrativecenter.entity_name') }}
                </div>
              </base-button-item-list>
            </span>
          </template>
        </base-table-select-more-actions-form>
        <div class="flex flex-row w-100">
          <base-table-search @toggleFilters="$emit('toggleFilters')" />
        </div>
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" hide-save @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        v-model="form.receiver"
        value-key="IdSede"
        value-type="data-item"
        single select-on-row-click
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading="isGeneralLoading"
        :update-columns="false"
        :selectedField="selectedField"
        @datastatechange="dataStateChange"
        @selectionchange="onSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <new-sede-dialog :dialogOpen="NewSedeDialog" :id-cliente="value" :id-cif-empresa="idCIFEmpresa" :mobile-version="isLower1024" @toggleDialog="toggleSedeDialog" />
      <new-admin-center-dialog :dialogOpen="NewAdminCenterDialog" :id-cliente="value" :id-cif-empresa="idCIFEmpresa" :mobile-version="isLower1024" @toggleDialog="toggleAdminCenterDialog" />
      <base-footer>
          <template slot="actions">
            <base-button-responsive  v-if="false" mode="primary" :text="$t('invoices.invoices_issuing.edit_receptor')" icon="check" @click="editReceptor" :loading="isGeneralLoading"/>
          </template>
      </base-footer>
      <slot name="layout-extend" />
    </template>
  </list-layout>
</template>

<script>
import { i18n } from '@/i18n'

import ListLayout from '@/components/layout/ListLayout.vue'
import NewSedeDialog from '@/components/Step1NewSedeDialog.vue'
import NewAdminCenterDialog from '@/components/Step1NewAdminCenterDialog.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'

import { getSociedadesSedesExtPag } from '@/services/configurations/getSociedadesSedesExtPag'

export default {
  name: 'step1-receiver',
  components: {
    // Loading,
    ListLayout,
    NewSedeDialog,
    NewAdminCenterDialog,
    KendoGridComponent,
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
    manual: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      stepId: '1',
      // Searches
      saveSearchDialog: false,
      // All
      spanish: true,
      vuexnamespace: 'invoicesIssuing/1',
      selectedField: 'selected',
      NewSedeDialog: false,
      NewAdminCenterDialog: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      rules: {
        receiver: [
          {
            required: true,
            message: i18n.t('app.select_data'),
            trigger: ['blur', 'change']
          }
        ]
      },
    }
  },
  computed: {
    form: function () {
      return this.$store.getters[this.vuexnamespace + '/form']
    },
    idCIFEmpresa: function () {
      return this.$store.getters['invoicesIssuing/form']?.issuer?.IdCIFEmpresa ?? ''
    },
    idCliente: function () {
      return this.$store.getters['invoicesIssuing/form']?.issuer?.IdCliente ?? ''
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isLower1650: function () {
      return this.$store.getters['app/getIsLower1650']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    tags: function () {
      var tags = this.$store.getters[this.vuexnamespace + '/getTags']
      return tags
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },

  },
  mounted () {
    if (!this.manual) {
      this.prepareStep()
    }
  },
  methods: {
    prepareStep: async function () {
      this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
      this.data = await this.applyFilters()
    },
    resetForm: function (excluded = []) {
      if (!excluded.includes(this.stepId)) {
        this.form.receiver = ''
      }
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        if (valid && doInput && (this.isFirstStep || this.value === '') && [3, 7, 8].includes(this.role)) {
          this.$emit('input', this.form.receiver?.Sociedad?.IdCliente ?? '')
        }
        callback(valid) 
      })
    },
    toggleSedeDialog: function () {
      this.NewSedeDialog = !this.NewSedeDialog
    },
    toggleAdminCenterDialog: function () {
      this.NewAdminCenterDialog = !this.NewAdminCenterDialog
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    getParamsFilter (data) {
      return {
        LocationRole: [2],
        TIN: data.cif ? data.cif.value : null,
        NameCorporateName: data.name ? data.name.value : null,
        direccion: data.direccion ? data.direccion.value : null,
        registro_mercantil: data.registro_mercantil ? data.registro_mercantil.value : null,
        email: data.email ? data.email.value : null,
        codigo_postal: data.codigo_postal ? data.codigo_postal.value : null,
        telefono: data.telefono ? data.telefono.value : null,
        pais: data.pais ? data.pais.value : null,
        idCliente: this.idCliente || null,
        idCIFEmpresa: this.idCIFEmpresa || null,
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = this.getParamsFilter(data)
      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)

      try {
        const data = await this.getItemsData(obj, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = (res.respuesta||[])

      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }

      return data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getSociedadesSedesExtPag(orders, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    removeAllTagsHandler: async function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    unselect: function () {
      this.resetForm()
    },
    onSelectionChange: function ({ isSelected }) {
      if (isSelected && this.form.receiver) {
        this.$emit('applystep')
      }
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    goSociedadCreation: async function () {
      await this.$store.dispatch('app/enterMode', 1)
      this.$router.push({ 
        name: 'masters/society/details',
        params: { id: -1, IdCliente: this.value } 
      })
    },
    editReceptor: function () {},
    addClient: function () {},
  },
}
</script>

<style scoped>
  @media (width < 1550px) {
    ::v-deep .table-tools > :first-child{
      gap: 0.5rem;
      flex-direction: column;
      justify-content: center;
    }
  }

  ::v-deep .table-tools{
    z-index: 10;
  }

</style>
